<template>
    <div class="socialist">
            <div style="width:100%; text-align:center;margin-bottom:10px">Социальные сети:</div>
            <div v-b-tooltip.hover title="Yandex">
              <b-button class="ya-button" tabindex="0" :href="`https://oauth.yandex.ru/authorize?response_type=token&client_id=9aa642bb862c4bfb922d04096c3a17ae&redirect_uri=${redirect_vk}`"> <yandex/> </b-button>
            </div>
            <div>
              <g-signin-button v-b-tooltip.hover title="Google"
                :params="googleSignInParams"
                @success="$emit('google', $event)"
                @error="$emit('error', $event)">
                <googleLogo />
              </g-signin-button>
            </div>
            <!--div>
              <fb-signin-button v-b-tooltip.hover title="Facebook"
                :params="fbSignInParams"
                @success="$emit('facebook', $event)"
                @error="$emit('error', $event)">
                <span class="material-icons" style="font-size:36px; outline:auto">facebook</span>
              </fb-signin-button>
            </div-->
            <div v-b-tooltip.hover title="VK">
              <b-button class="vk-button" tabindex="0" :href="`https://oauth.vk.com/authorize?client_id=7606335&display=page&redirect_uri=${redirect_vk}&scope=email&response_type=code&v=5.124`"> <VKLogo/> </b-button>
            </div>
            <div v-b-tooltip.hover title="OK">
              <a class="ok-button" tabindex="0" :href="`https://connect.ok.ru/oauth/authorize?client_id=512000667489&scope=VALUABLE_ACCESS&response_type=token&redirect_uri=${redirect_href}`"> <OKLogo/> </a>
            </div>
            <!--div>
              <a class="inst-button" tabindex="0" :href="`https://api.instagram.com/oauth/authorize?client_id=824347501663095&redirect_uri=${redirect_inst}&scope=user_profile,user_media&response_type=code`"> <instagram/> </a>
            </div-->
          </div>
</template>

<script>
import VKLogo from '@app/assets/icons/vk-social-network-logo.svg?inline';
import googleLogo from '@app/assets/icons/google.svg?inline';
import OKLogo from '@app/assets/icons/Odnoklassniki.svg?inline';
//import instagram from '@app/assets/icons/instagram.svg?inline';
import yandex from '@app/assets/icons/yandex_icon.svg?inline';



export default {
  components: {
    VKLogo,
    googleLogo,
    OKLogo,
   // instagram,
    yandex
  },
  props: {
    redirect: String
  },
  data() {
      return {
        googleSignInParams: {
            client_id: '895949417832-d1o922c3thm4mhtjqq8dhk54d99jdoq6.apps.googleusercontent.com'
        },
        fbSignInParams: {
            scope: 'email,user_likes',
            return_scopes: true
        },
        showPopover: false,
        redirect_href: window.location.origin + '?redirect=' + this.redirect, // process.env.VUE_APP_API_URL
        redirect_vk: window.location.origin,
        redirect_inst: window.location.origin + '/'
      };
  }
};
</script>

<style lang="scss" scoped>
    .socialist {
  display: flex;
  padding: 15px;
  justify-content: space-between;
  flex-wrap: wrap;
  border-top: 1px solid lightgray;
  padding-top: 2px;
}
.ok-button {
  background: none;
  width:36px;
  height: 36px;
  padding: 0;
  border-color: white;
  border-radius:10px;
}
.ok-button:hover {
  box-shadow: 0px 1px 14px 4px grey;

}
.vk-button {
  background: #5281c0;
  color: white;
  padding: 2px 10px;
  width: 36px;
  height: 36px;
  padding: 0;
}
.vk-button:hover {
  box-shadow: -1px 2px 9px 1px grey;
}
.ya-button {
  background: none;
  color: white;
  padding: 2px 10px;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none
}
.ya-button:hover {
  box-shadow: -1px 2px 9px 1px grey;
}
.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 0;
  width: 36px;
  height:36px;
  border-radius: 3px;
  background-color: whitesmoke;
  color: gray;
  cursor: pointer;
  outline: auto;
}
.g-signin-button:hover {
  box-shadow: -1px 2px 9px 1px grey;
}
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  border-radius: 3px;
  height: 36px;
  width:36px;
  background-color: whitesmoke;
  color: #4267b2;
  cursor: pointer;
}
.fb-signin-button:hover {
  box-shadow: -1px 2px 9px 1px grey;
}
</style>